var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDescriptionPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8263 2.89474C11.0579 2.66316 11.0579 2.31579 10.8263 2.08421L9.49474 0.752632C9.26316 0.521053 8.91579 0.521053 8.68421 0.752632L7.64211 1.79474L9.8421 3.99474L10.8263 2.89474ZM0.578947 8.8V11H2.77895L9.14737 4.57368L7.00526 2.37368L0.578947 8.8ZM2.89474 0V1.73684H4.63158V2.89474H2.89474V4.63158H1.73684V2.89474H0V1.73684H1.73684V0H2.89474Z",
    fill: "#959CA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDescriptionPlaceholder);
export default __webpack_public_path__ + "static/media/addDescriptionPlaceholder.c2ac6ac019b0d87e5427f7a93705ff8e.svg";
export { ForwardRef as ReactComponent };